import { useDispatch, useSelector } from "react-redux";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { TelerikReport } from "../components/TelerikReport";
import { useEffect } from "react";
import {
  actualUIState,
  setActiveTab,
} from "../redux/reducers/uiShared.reducer";
import {
  PRODUCTS_ACCESS_CONTROL_REPORTS,
  ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT,
} from "../utils/constants";
import { Spinner } from "../components/Spinner";
import { verifyModuleAccess } from "../utils/accessUtils";
import { ForbiddenPage } from "./ForbiddenPage";
import { selectAuth } from "../../SharedModule/redux/reducers/auth.reducer";

export const AccessControlReportPageByGitlabProject = () => {
  const auth = useSelector(selectAuth);
  
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken
  };

  const dispatch = useDispatch();

  const { userRolesProductsModule, isLoadingRolesProductsModule } =
    useSelector(actualUIState);

  useEffect(() => {
    document.title = "The Hub - Access Control Report By Gitlab Project";
    dispatch(setActiveTab(ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT));
  }, []);

  return (
    <>
      {isLoadingRolesProductsModule && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {!isLoadingRolesProductsModule &&
        !verifyModuleAccess(
          true,
          PRODUCTS_ACCESS_CONTROL_REPORTS,
          userRolesProductsModule
        ) && <ForbiddenPage />}
      {!isLoadingRolesProductsModule &&
        verifyModuleAccess(
          true,
          PRODUCTS_ACCESS_CONTROL_REPORTS,
          userRolesProductsModule
        ) && (
          <TelerikReport
            title="Access Control Report By Gitlab Project"
            reportName="AccessControlReportByGitlabProject.trdp"
            parameters={parameters}
            parametersAreaVisible={true}
          />
        )}
    </>
  );
};
